
/** @jsx jsx */

import { jsx, css } from '@emotion/react';
import React from 'react'
import zekkeiData from '../../content/zekkei.yml';
import * as breakpoint from '../../styles/breakpoints.module.scss';
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image"
import { BasicContainer } from '../StyledComponent';
import {  Link  } from 'gatsby';
import * as styleConfig from '../../styles/config.module.scss';
import { withPrefix } from 'gatsby'

const ZekkeiListBlock =  ({ assetsList, crossSection, children, current }) => {


	return (
    <div css={css`
      padding-bottom:72px;
      ${crossSection ? 'background:#F4F4F4;padding-top:72px;': ''}

      @media only screen and (max-width: ${breakpoint.smMax})
      {
        margin: 0 -${styleConfig.glitterSMhorizontal} ;
        padding: 48px ${styleConfig.glitterSMhorizontal} 64px;
      }

      @media only screen and (max-width: ${breakpoint.xsMax})
      {
        margin: 0 -${styleConfig.glitterXShorizontal} ;
        padding: 48px ${styleConfig.glitterXShorizontal} 48px;
      }

    `}>
      <BasicContainer css={css`
        max-width:1536px;

        display:flex;
        flex-wrap: wrap;
        
        @media only screen and (max-width: ${breakpoint.smMax})
        {
          display:block;
        }
        
        `}>
        {zekkeiData.map((item,index) => 
        item.id === current && crossSection ?
        <React.Fragment key={`zekkeiAreaBlock_${index}`}>
        </React.Fragment>
        :
        <div key={`zekkeiAreaBlock_${index}`} css={css`
          margin-bottom:48px;width:50%;
          padding:0 16px;
          
          @media only screen and (max-width: ${breakpoint.smMax})
          {
            margin-bottom:32px;
            padding:0;
            width:100%;
          }

          @media only screen and (max-width: ${breakpoint.xsMax})
          {
            margin-bottom:32px;
          }
          `}>
          <Link css={css`margin-bottom:16px;display:block;
            border-radius:12px;background:#000000;
            transition: all .3s;
            &:hover{
              opacity:0.7;
            }

            @media only screen and (max-width: ${breakpoint.xsMax})
            {
              border-radius:6px;
            }

          `} to={`/zekkei/${item.id}`}>
            <div css={css`
              border-radius:12px;overflow:hidden;
              transform: translateY(-4px);
              transition: all .3s;
              background:#eee url(${withPrefix('loading.gif')}) center no-repeat;
              a:hover &{
                transform: translateY(-2px);
              }

              @media only screen and (max-width: ${breakpoint.xsMax})
              {
                border-radius:6px;
              }
            `}>
              <GatsbyImage 
                image={withArtDirection(getImage(assetsList[item.cover.desktop]), [
                  {
                    media: `(min-width: ${breakpoint.mdMin})`,
                    image: getImage(assetsList[item.cover.desktop]),
                  },
                  {
                    media: `(max-width: ${breakpoint.smMax}) and (min-width: ${breakpoint.smMin})`,
                    image: getImage(assetsList[item.cover.tablet]),
                  },
                  {
                    media: `(max-width: ${breakpoint.xsMax})`,
                    image: getImage(assetsList[item.cover.mobile]),
                  }
                ])}
                alt={item.title}
                />
            </div>
          </Link>
          <div css={css`
            color:#000000;text-align:left;
            font-size: 14px;
            line-height: 24px;
            
          `}>{item.desc.replace(/<br\/>/g,'')}</div>
        </div>)
        }
        
      </BasicContainer>
      {children}
    </div>
	);
}

ZekkeiListBlock.displayName = 'ZekkeiListBlock';

export default ZekkeiListBlock;

